import React, { useEffect, useState, useRef } from 'react';
import FormInputField from 'src/components/common/formInputField';
import { useForm, Controller } from 'react-hook-form';
import FormSelector from 'src/components/common/formSelector';
import { useVideosActions } from 'src/store/videos/actions';
import { useDispatch } from 'react-redux';
import { useChannelActions } from 'src/store/channel/actions';
import { RootState } from 'src/store/reducers/state';
import { useSelector } from 'react-redux';
import { defaultDateFormatter, successMsg } from 'src/components/utilities/utils';
import { errorMsg } from 'src/components/utilities/utils';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { Link, useLocation } from 'react-router-dom';
import { convertHourMinuteToSecond } from 'src/components/utilities/utils';
import { useLoginActions } from 'src/store/login/actions';
import { customFilterOption } from 'src/components/utilities/utils';
import moment from 'moment';
type locationState = {
    channelId: string;
};
const CreateNewContent = ({ channelName, eventTitle, setNewVideoData, setChannelId }: any) => {
    const dispatch = useDispatch();
    const loginAction = useLoginActions(dispatch);
    const btnRef = useRef<HTMLButtonElement>(null);
    const [finalChannels, setFinalChannels] = useState<any>();
    const videoAction = useVideosActions(dispatch);
    const channelAction = useChannelActions(dispatch);
    const navigate = useNavigate();
    const location = useLocation();
    const [source, SetSource] = useState(2);
    const userData = localStorage.getItem('userData');
    const finalUserData = userData && JSON.parse(userData);
    const { channelId } = (location.state as locationState) || {};
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
        setValue,
        watch,
        getValues
    } = useForm();

    const {
        channelList,
        isVideoUploaded,
        message,
        isLiveStreamError,
        isAddLiveStreamLoading,
        liveStreamId,
        liveMedia,
        productAccess,
        defaultDateFormat,
    } = useSelector((state: RootState) => {
        return {
            channelList: state.channel.channelList,
            isVideoUploaded: state.videos.isVideoUploaded,
            message: state.videos.message,
            isLiveStreamError: state.videos.isLiveStreamError,
            isAddLiveStreamLoading: state.videos.isAddLiveStreamLoading,
            liveStreamId: state.videos.liveStreamId,
            liveMedia: state.videos.liveMedia,
            productAccess: state.videos.isProductAccess,
            defaultDateFormat: state.login.defaultDateFormat
        };
    });

    useEffect(() => {
        if (channelList && channelList.length) {
            const options = channelList.map((item) => ({
                value: item.id,
                label: item.displayText
            }));
            setFinalChannels(options);
        }
    }, [channelList]);

    useEffect(() => {
        channelAction.getChannelListRequest();
    }, []);

    const onSubmit = (data: any) => {
        if (data) {
            setNewVideoData({
                title: data.title,
                date: data.date,
                time: data.time,
                duration: moment(
                    `${data.hour}:${data.minute}`,
                    'HH:mm'
                ).format('HH:mm')
            });
        }
        setChannelId(data.channelId.value)
        const finalData = {
            title: data.title,
            channelId: data.channelId.value,
            liveStreamId: data.liveMedia,
            date: defaultDateFormatter(data.date),
            time: data.time,
            duration: convertHourMinuteToSecond(data.hour, data.minute),
            useLiveStreamDefaultSettings: data.useLiveStreamDefaultSettings,
            autoPublishOnDemand: data.autoPublishOnDemand,
            cloudRecording: data.cloudRecording,
            videoSourceId: source,
            useLiveMeeting: data.useLiveMeeting,
            onDemandCaptionEnable: data.onDemandCaptionEnable
        };
        videoAction.addLiveStreamRequest(finalData);
    };
    useEffect(() => {
        if (isVideoUploaded) {
            successMsg(message);
        }
    }, [isVideoUploaded]);
    useEffect(() => {
        if (isLiveStreamError) {
            errorMsg('Error');
            videoAction.resetVideoLibraryRequest();
        }
    }, [isLiveStreamError]);
    const handleCancelClick = () => {
        navigate('/channels');
    };
    useEffect(() => {
        videoAction.getLiveMediaRequest();
    }, []);

    useEffect(() => {
        videoAction.getProductAccessRequest();
        if (!defaultDateFormat || Object.keys(defaultDateFormat).length === 0) {
            loginAction.getDefaultdateFormatRequest();
        }
    }, []);

    const watchLiveMedia = watch('liveMedia');

    useEffect(() => {
        const filterData = liveMedia && liveMedia.filter((item) => item.id === watchLiveMedia);
        if (filterData && filterData.length) {
            setValue('cloudRecording', filterData[0]?.cloudRecordingEnable);
            setValue('autoPublishOnDemand', filterData[0]?.autoPublishOnDemand);
        }
    }, [watchLiveMedia]);

    useEffect(() => {
        setValue('date', moment().format('YYYY-MM-DD'));
    }, []);

    useEffect(() => {
        if (channelList && channelName) {
            const selectedChannel = channelList && channelList.filter((item) => item.id === channelName);
            if (selectedChannel) {
                const defaultChannel = {
                    value: selectedChannel[0] ? selectedChannel[0].id : '',
                    label: selectedChannel[0] ? selectedChannel[0].displayText : ''
                };
                setValue('channelId', defaultChannel);
                setValue('title', eventTitle);
            }
        }
    }, [channelList, channelName]);

    const selectStyles = {
        control: (base: any, state: any) => ({
            ...base,
            minHeight: '42px',
            borderRadius: '8px',
            borderColor: state.isFocused ? '#7c3aed' : '#e5e7eb',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(124, 58, 237, 0.12)' : 'none',
            '&:hover': { borderColor: '#c4b5fd' }
        }),
        placeholder: (base: any) => ({ ...base, color: '#9ca3af', fontSize: '14px' }),
        singleValue: (base: any) => ({ ...base, fontSize: '14px', color: '#111827' }),
        option: (base: any, state: any) => ({
            ...base,
            fontSize: '14px',
            backgroundColor: state.isSelected ? '#7c3aed' : state.isFocused ? '#f5f3ff' : 'white',
            color: state.isSelected ? 'white' : '#111827'
        })
    };

    return (
        <div className="px-4 sm:px-8 mt-5 sm:mt-6 pb-6 sm:pb-8">
            <button ref={btnRef} type="button" className="hidden" data-bs-dismiss="modal" aria-label="Close" />

            <h3 className="text-base font-bold text-gray-900 m-0">Create New Live Stream / Video</h3>
            <p className="text-xs text-gray-500 mt-1">
                Set up the live stream details. You can manage additional settings after the event is created.
            </p>

            <form className="mt-6" onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col gap-2 xl:grid xl:grid-cols-2 xl:gap-8">
                    <div>
                        <div className="form-group mb-4">
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                Title <span className="text-red-500">*</span>
                            </label>
                            <FormInputField
                                label={''}
                                type={'text'}
                                fieldName={'title'}
                                register={register}
                                errors={errors}
                                isRequired={true}
                            />
                        </div>

                        <div className="form-group mb-4">
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                Channel <span className="text-red-500">*</span>
                            </label>
                            {channelList && (
                                <Controller
                                    render={({
                                        field: { onChange, onBlur, value, ref },
                                        fieldState: { error }
                                    }) => (
                                        <Select
                                            filterOption={customFilterOption}
                                            options={finalChannels}
                                            value={value}
                                            id="channelId"
                                            styles={selectStyles}
                                            onChange={(val) => onChange(val)}
                                            isLoading={channelList.length ? false : true}
                                        />
                                    )}
                                    name="channelId"
                                    control={control}
                                    rules={{ required: true }}
                                />
                            )}
                            <p className="text-xs text-gray-400 mt-1.5">
                                Select the channel this live stream will be added to.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
                            <div className="form-group mb-4">
                                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                    Date <span className="text-red-500">*</span>
                                </label>
                                <FormInputField
                                    label={''}
                                    type={'date'}
                                    fieldName={'date'}
                                    register={register}
                                    errors={errors}
                                    isRequired={true}
                                />
                            </div>
                            <div className="form-group mb-4">
                                <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                    Start Time <span className="text-red-500">*</span>
                                </label>
                                <FormInputField
                                    label={''}
                                    type={'time'}
                                    fieldName={'time'}
                                    register={register}
                                    errors={errors}
                                    isRequired={true}
                                />
                            </div>
                        </div>

                        <div className="form-group mb-4">
                            <label className="block text-sm font-semibold text-gray-700 mb-1.5">
                                Duration (hh:mm)
                            </label>
                            <div className="flex items-start sm:items-center gap-3">
                                <div className="flex flex-col sm:flex-row sm:items-center flex-1 min-w-0">
                                    <select className="input-style w-full min-w-0 rounded-lg" id="hour" {...register('hour')}>
                                        {Array.from(Array(23).keys()).map((item) => {
                                            return (
                                                <option key={item} value={item}>
                                                    {item < 10 ? `0${item}` : item}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <span className="mt-1 sm:mt-0 sm:ml-2 text-sm text-gray-500">Hours</span>
                                </div>
                                <div className="flex flex-col sm:flex-row sm:items-center flex-1 min-w-0">
                                    <select className="input-style w-full min-w-0 rounded-lg" {...register('minute')}>
                                        {Array.from({ length: Math.ceil(60 / 5) }, (_, index) => index * 5).map(
                                            (item) => {
                                                return (
                                                    <option key={item} value={item}>
                                                        {item <= 5 ? `0${item}` : item}
                                                    </option>
                                                );
                                            }
                                        )}
                                    </select>
                                    <span className="mt-1 sm:mt-0 sm:ml-2 text-sm text-gray-500">Minutes</span>
                                </div>
                            </div>
                            <p className="text-xs text-gray-400 mt-1.5">e.g. 01:00 for 1 hour</p>
                        </div>
                    </div>

                    <div className="rounded-xl bg-indigo-50/60 border border-indigo-100 p-4 sm:p-5 flex flex-col min-w-0">
                        <h4 className="text-sm font-bold text-gray-900 mb-3">Live Stream Source</h4>
                        <div className="grid grid-cols-2 gap-3">
                            <div
                                onClick={() => SetSource(1)}
                                className={`relative cursor-pointer rounded-xl bg-white p-3 sm:p-4 text-center transition-all ${source === 1
                                    ? 'border-2 border-indigo-500 shadow-sm'
                                    : 'border-2 border-gray-200 hover:border-indigo-200'
                                    }`}>
                                <span
                                    className={`absolute top-2.5 right-2.5 h-4 w-4 rounded-full border-2 flex items-center justify-center ${source === 1 ? 'border-indigo-600' : 'border-gray-300'
                                        }`}>
                                    {source === 1 && <span className="h-2 w-2 rounded-full bg-indigo-600" />}
                                </span>
                                <div
                                    className={`mx-auto mb-2 h-11 w-11 rounded-full flex items-center justify-center ${source === 1 ? 'bg-indigo-600 text-white' : 'bg-indigo-100 text-indigo-500'
                                        }`}>
                                    <i className="fa fa-camera text-lg"></i>
                                </div>
                                <h5 className="font-semibold text-sm text-gray-900 m-0">Webcam</h5>
                                <p className="text-xs text-gray-400 mt-1 mb-0 leading-snug">
                                    Broadcast using your webcam and audio.
                                </p>
                            </div>

                            <div
                                onClick={() => SetSource(2)}
                                className={`relative cursor-pointer rounded-xl bg-white p-3 sm:p-4 text-center transition-all ${source === 2
                                    ? 'border-2 border-indigo-500 shadow-sm'
                                    : 'border-2 border-gray-200 hover:border-indigo-200'
                                    }`}>
                                <span
                                    className={`absolute top-2.5 right-2.5 h-4 w-4 rounded-full border-2 flex items-center justify-center ${source === 2 ? 'border-indigo-600' : 'border-gray-300'
                                        }`}>
                                    {source === 2 && <span className="h-2 w-2 rounded-full bg-indigo-600" />}
                                </span>
                                <div
                                    className={`mx-auto mb-2 h-11 w-11 rounded-full flex items-center justify-center ${source === 2 ? 'bg-indigo-600 text-white' : 'bg-indigo-100 text-indigo-500'
                                        }`}>
                                    <i className="fas fa-key fa-rotate-180 text-lg"></i>
                                </div>
                                <h5 className="font-semibold text-sm text-gray-900 m-0">Streaming Software</h5>
                                <p className="text-xs text-gray-400 mt-1 mb-0 leading-snug">
                                    Use RTMP from OBS, vMix, etc.
                                </p>
                            </div>
                        </div>

                        <h4 className="text-sm font-bold text-gray-900 mt-5 mb-3">Live Media Settings <span className="text-red-500">*</span></h4>

                        <div className="form-group mb-4">
                            <FormSelector
                                label={''}
                                fieldName={'liveMedia'}
                                register={register}
                                errors={errors}
                                isRequired={false}
                                data={
                                    liveMedia &&
                                    liveMedia.map((item) => {
                                        return { id: item.id, name: item.mediaName };
                                    })
                                }
                                options={'name'}
                            />
                        </div>

                        <div className="form-check mb-2">
                            <input
                                className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-indigo-600 checked:border-indigo-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                type="checkbox"
                                id="useDefaultSetting"
                                {...register('useLiveStreamDefaultSettings')}
                                defaultChecked={true}
                            />
                            <label className="form-check-label inline-block text-sm text-gray-700" htmlFor="flexCheckDefault">
                                Use default settings
                            </label>
                        </div>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-indigo-600 checked:border-indigo-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                type="checkbox"
                                id="flexCheckChecked"
                                {...register('cloudRecording', {
                                    onChange: (e) => {
                                        setValue('autoPublishOnDemand', false);
                                    }
                                })}
                                disabled={watch('useLiveStreamDefaultSettings')}
                            />
                            <label className="form-check-label inline-block text-sm text-gray-700" htmlFor="flexCheckChecked">
                                Cloud recording
                            </label>
                        </div>
                        <div className="form-check mb-2">
                            <input
                                className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-indigo-600 checked:border-indigo-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                type="checkbox"
                                id="flexCheckChecked"
                                {...register('autoPublishOnDemand')}
                                disabled={watch('useLiveStreamDefaultSettings') || !watch('cloudRecording')}
                            />
                            <label className="form-check-label inline-block text-sm text-gray-700" htmlFor="flexCheckChecked">
                                Auto publish on-demand
                            </label>
                        </div>

                        {productAccess && productAccess.liveMeeting && source === 1 && (
                            <div className="form-check mb-2">
                                <input
                                    className="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-indigo-600 checked:border-indigo-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                    type="checkbox"
                                    id="useLiveMeeting"
                                    {...register('useLiveMeeting')}
                                />
                                <label className="form-check-label inline-block text-sm text-gray-700" htmlFor="flexCheckDefault">
                                    Use low latency meeting
                                </label>
                            </div>
                        )}

                        <div className="mt-3">
                            <div className="flex items-center flex-wrap">
                                <div
                                    className={`flex items-center ${productAccess && !productAccess.aiGeneratedCaptions ? 'ai-background' : ''
                                        }`}>
                                    <div className="mr-2 flex">
                                        <label className="text-sm text-gray-700 mb-0">OnDemand Captions AI</label>
                                        {/* <i className="fa-solid fa-wand-magic-sparkles ai-icon"></i> */}
                                    </div>
                                    <div className="form-check form-switch pl-0 flex-items mb-0">
                                        <div className="relative">
                                            <input
                                                disabled={
                                                    productAccess && !productAccess.aiGeneratedCaptions ? true : false
                                                }
                                                className="form-check-input switch-btn"
                                                type="checkbox"
                                                id="onDemandCaptionEnable"
                                                {...register('onDemandCaptionEnable')}
                                            />
                                            <i className="fas fa-check checkbox-tick hidden"></i>
                                            <i className="fas fa-times checkbox-cross"></i>
                                        </div>
                                    </div>
                                </div>
                                {productAccess && !productAccess.aiGeneratedCaptions && (
                                    <p className="bg-purple-100 mt-2 sm:mt-0 sm:ml-2 text-xs rounded px-2 py-1 mb-0">
                                        {/* <i className="fa-solid fa-wand-magic-sparkles"></i> */}
                                        <span className="font-bold">New! </span>
                                        <span className="font-medium">
                                            Add Captions AI to any paid plan for a monthly fee.{' '}
                                            <a
                                                href={`${defaultDateFormat.dateFormat === 'MM/dd/yyyy'
                                                    ? 'https://buy.stripe.com/5kA3fl3OpcIvcjC8wy'
                                                    : 'https://buy.stripe.com/8wMdTZdoZaAn5VeeUV'
                                                    }`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="underline text-indigo-700 cursor-pointer">
                                                Get Captions AI
                                            </a>
                                        </span>
                                    </p>
                                )}
                            </div>
                        </div>

                        <div className="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-3 mt-auto pt-6">
                            <button
                                type="button"
                                onClick={handleCancelClick}
                                data-bs-dismiss="modal"
                                className="w-full sm:w-auto px-6 py-2 rounded-lg border border-gray-300 bg-white text-sm font-semibold text-gray-700 hover:bg-gray-50">
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isAddLiveStreamLoading}
                                className={`w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2 rounded-lg text-sm font-semibold text-white transition-colors ${isAddLiveStreamLoading
                                    ? 'bg-indigo-400 cursor-not-allowed'
                                    : 'bg-indigo-600 hover:bg-indigo-700'
                                    }`}>
                                Create Live Stream
                                {isAddLiveStreamLoading && (
                                    <svg
                                        className="animate-spin"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none">
                                        <circle
                                            className="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                        />
                                        <path
                                            className="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default CreateNewContent;